module.exports = __webpack_public_path__ + "static/media/contact_grey.2f48a6d7.svg";